import BrandName from '../constants/brand-name.map';
import getLocaleFromExpediaCookie from './expedia';
import { getLocale } from './hotel';

export default {
  [BrandName.expedia]: getLocaleFromExpediaCookie,
  [BrandName.hotels]: getLocale,
};
